import { useEffect, useState } from 'react';
import { errorText } from '../lib/bridge';
import { t } from '../lib/i18n';
import { stopScreenWork, useAssistantDoing, useAssistantLocked, useScreenWorking } from '../lib/screen';
import { STEP } from './Assistant';
import { MascotMark } from './Mascot';
import { toast } from './Toasts';

/**
 * While 馍馍's turn goes (lib/screen.ts: from the message being sent until its reply — thinking, or working this window's screen): a
 * thin band sliding along the window's top edge, and in the middle of the title bar a small pill saying what it is on, with 停止 (the
 * chat is out of the way meanwhile, and comes back with the reply). Over the page but taking no clicks (except the pill's): the
 * user's hands stay on the screen. It fades out when the turn ends.
 */
export function ScreenWork() {
  const on = useAssistantLocked();
  const working = useScreenWorking();
  const doing = useAssistantDoing();
  // (kept a moment after the turn ends, to fade out)
  const [shown, setShown] = useState(on);
  const [stopping, setStopping] = useState(false);
  useEffect(() => {
    if (on) {
      setShown(true);
      setStopping(false);
      return;
    }
    const timer = setTimeout(() => setShown(false), 240);
    return () => clearTimeout(timer);
  }, [on]);
  if (!shown) return null;

  const stop = async () => {
    setStopping(true);
    try {
      await stopScreenWork();
    } catch (e) {
      toast(errorText(e), 'error');
      setStopping(false);
    }
  };

  return (
    <div className={`screen-work ${on ? '' : 'is-leaving'}`} role="status">
      <div className="screen-work__bar" aria-hidden />
      <div className="screen-work__pill">
        <MascotMark className="screen-work__cat" />
        <span>{working ? t('馍馍正在操作…') : (doing && STEP[doing]?.()) || t('馍馍在想…')}</span>
        <button type="button" className="screen-work__stop" disabled={stopping || !on} onClick={() => void stop()}>
          {t('停止')}
        </button>
      </div>
    </div>
  );
}
